<template>
    <div class="image-background-container accordion-content pb-4">
        <input type='file' ref="fileUpload" accept="image/png,image/jpeg,image/gif" hidden/>
        <div v-if="!bgImage">
            <button class="btn line-height-normal text-left" type="button" @click="uploadFile">
                Bild hochladen (max. 3 MB)
                <div class="sublabel">GIF, JPG, PNG</div>
            </button>
        </div>
        <div v-else>
            <div class="flex">
                <div :style="{
                    'background-image': 'url(' + bgImage + ')'
                }" class="image-preview w-28 h-20 mr-3 flex-shrink">
                    <div class="icon-trash" @click="removeFile"></div>
                </div>

                <div class="w-60 flex-grow">
                    <div class="inline-block" v-show="cropMode">
                        <button class="btn w-full" type="button" @click="doneCropping">fertig positioniert</button>
                    </div>

                    <div class="inline-block" v-show="!cropMode">
                        <button class="btn w-full" type="button" @click="adjustCrop">Bild positionieren</button>
                    </div>

                    <div class="grid grid-cols-1 form-element-wrapper mt-2">
                        <div class="form-element">
                            <Checkbox type="checkbox"
                                name="effect"
                                v-model="backgroundEffect"
                                checkValue="grayscale"
                                uncheckValue="none"
                                connected="true"
                                @change="setBackgroundEffect()"
                            >Schwarz/Weiß</Checkbox>
                        </div>

                        <div class="form-element ml-0">
                            <Checkbox type="checkbox"
                                name="effect"
                                v-model="backgroundEffect"
                                checkValue="sepia"
                                uncheckValue="none"
                                connected="true"
                                @change="setBackgroundEffect()"
                            >Sepia</Checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-2 text-left text-orange" v-if="imageTooSmall">ACHTUNG: Dein Hintergrundbild hat eine zu geringe Auflösung für den Druck! Bitte lade ggf. ein Bild mit höherer Auflösung hoch.</div>


            <div class="grid form-element-wrapper mt-4">
                <strong>Farben anpassen</strong>
            </div>
            <div class="grid grid-cols-2 form-element-wrapper">
                <div class="mt-1 form-element">
                    <div class="label">Amplitude</div>
                    <ColorPicker name="color"
                        :value="color"
                        @change="setWaveColor($event, true)"
                    ></ColorPicker>
                </div>

                <div class="mt-1 form-element" v-show="textConfigurations.length > 0">
                    <div class="label">Text</div>
                    <ColorPicker name="color"
                        :value="textColor"
                        @change="setTextColor($event)"
                    ></ColorPicker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pipeline from "../../../Pipeline/Pipeline.js";
import { mapFields } from 'vuex-map-fields';
import Checkbox from '~/scripts/Components/Checkbox.vue';
import ColorPicker from "../../../Components/ColorPicker.vue";

export default {
    computed: {
        ...mapFields({
            color: 'stageConfiguration.color',
            textConfigurations: 'textConfigurations',
            bgImage: 'stageConfiguration.background.image',
            customTextColor: 'stageConfiguration.customTextColor',
            backgroundEffect: 'stageConfiguration.background.effect'
        }),

        textColor() {
            return this.customTextColor ?? this.color;
        }
    },

    components: {
        Checkbox,
        ColorPicker
    },

    data() {
        return {
            cropMode: false,
            imageTooSmall: false
        }
    },
    mounted() {
        const self = this;

        this.$refs.fileUpload.addEventListener('change', async function() {
            let base64 = await self.readUploadedFileAsBase64Str(this);

            self.$store.commit('updateField', {
                path: 'stageConfiguration.background.type',
                value: 'image'
            });

            self.$store.commit('updateField', {
                path: 'stageConfiguration.background.image',
                value: base64
            });

            self.cropMode = true;
            await Pipeline.setImageBackground();
            Pipeline.addBackgroundCropControls();
        });

        this.$root.$on('disableCropMode', () => {
            this.doneCropping();
        })
    },

    methods: {
        uploadFile() {
            this.$refs.fileUpload.click();
        },

        removeFile() {
            this.doneCropping();
            this.bgImage = null;
            this.imageTooSmall = false;

            this.$store.commit('updateField', {
                path: 'stageConfiguration.background.image',
                value: ''
            });

            this.$store.commit('updateField', {
                path: 'stageConfiguration.background.transform',
                value: null
            });

            this.$store.commit('updateField', {
                path: 'stageConfiguration.background.effect',
                value: null
            });

            this.$store.commit('updateField', {
                path: 'stageConfiguration.background.imageTransformer',
                value: null
            });

            Pipeline.setImageBackground();
            Pipeline.setBackgroundOrder();
        },

        adjustCrop() {
            this.cropMode = true;
            Pipeline.addBackgroundCropControls();
        },

        doneCropping() {
            this.cropMode = false;
            Pipeline.removeBackgroundCropControls();
        },

        setBackgroundEffect() {
            this.$store.commit('updateField', {
                path: 'stageConfiguration.background.effect',
                value: this.backgroundEffect
            });

            Pipeline.setBackgroundEffect();
        },

        async readUploadedFileAsBase64Str(input) {
            return new Promise((resolve, reject) => {
                let self = this;
                const stage = this.$store.state.stage;

                if (input.files && input.files[0]) {
                    var reader = new FileReader();

                    reader.onload = function(e) {
                        const image = new Image();
                        image.addEventListener('load', () => {
                            self.imageTooSmall = (image.width < stage.width() || image.height < stage.height());
                        });
                        image.src = e.target.result;
                        resolve(e.target.result);
                    }

                    reader.readAsDataURL(input.files[0]); // convert to base64 string
                }
            });
        },

        setWaveColor(color, triggerChange) {
            this.doneCropping();
            Pipeline.updateSingleWaveColor(0, color, triggerChange);
        },

        setTextColor(textColor) {
            this.doneCropping();
            this.$store.commit('updateField', {
                path: 'stageConfiguration.customTextColor',
                value: textColor
            });
            Pipeline.updateTextColors(textColor, false);
        }
    }
};
</script>
